import { useEffect } from 'react';

const AdsterraNativeBanner = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//pl27983702.effectivegatecpm.com/4f9de5c792ebaa678ae9b2f1afe17744/invoke.js';
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="container-4f9de5c792ebaa678ae9b2f1afe17744" />;
};

export default AdsterraNativeBanner;